import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/user/auth'
import { useUserStore } from '@/stores/user/user'
import { useToastsStore } from '@/stores/notifications/toasts'
import axios from 'axios'
import { getResponse, getError } from '@/composables/api'

export const useUserSettingsStore = defineStore({
   id: 'user-settings',
   state: () => ({
      displayNameChecked: 0,
      profileUpdated: 0,
      displayNameStatus: null,
      storeUser: useUserStore(),
      storeAuth: useAuthStore(),
      storeToasts: useToastsStore(),
   }),
   actions: {
      updateVisibilities(visibility) {
         axios.put('user/settings/visibilities', { visibility: visibility }).then(response => {
            this.storeUser.getUser()
         })
      },
      updateProfileVisibility(visibility) {
         axios.put('user/settings/privacy', { visibility: visibility }).then(response => {
            this.storeUser.getUser()
         })
      },
      updateTimezone(timezone) {
         axios.put('user/settings/timezone', { timezone: timezone }).then(response => {
            this.storeToasts.sendToast('Your timezone has been updated.')
         })
      },
      updateAvatar(avatarID) {
         axios.put('user/settings/avatar', { avatar_id: avatarID }).then(response => {
            this.storeUser.getUser()
            this.storeToasts.sendToast('Your Avatar has been updated.')
         })
      },
      updateProfile(profile) {
         axios.put('user/settings/profile', profile).then(response => {
            setTimeout(() => {
               this.storeUser.getUser()
               this.displayNameStatus = null
               this.profileUpdated = this.profileUpdated + 1
               this.storeToasts.sendToast('Your profile has been updated.')
            }, 500)
         })
      },
      checkDisplayName(name) {
         axios.put('user/settings/display-name', { display_name: name }).then(response => {
            setTimeout(() => {
               this.displayNameChecked = this.displayNameChecked + 1
               this.displayNameStatus = getResponse(response)
            }, 1000)
         }).catch(error => {
            this.displayNameChecked = this.displayNameChecked + 1
            this.displayNameStatus = error.response.data
         })
      }
   }
})